import React, { useState } from "react";
import { FaUserPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import Loader2 from "../DashboardComponents/Loader/Loader2";
import { getinsights } from "../../Api/buildsheetApi"
import { useParams } from "react-router-dom";
import './BuildsheetInsights.css'
import { IoCloseSharp } from "react-icons/io5";

function BuildsheetInsights({ id, closeButton }) {

    // const { id } = useParams();

    const [isLoading, setIsLoading] = useState(false);

    const [data, setData] = useState([]);

    React.useEffect(() => {
        setIsLoading(true);
        getinsights({ project_id: id }).then((res) => {
            console.log("res data", res.data.data);
            setData(res.data.data);
            setIsLoading(false);
        });
    }, []);


    return (
        <>
            {
                isLoading ? (
                    <div className="loading">
                        <Loader2 />
                    </div>
                ) : (
                    <>
                        <div>
                            {/* <div className="main-page-body-content-header">
                                <HeaderAdmin />
                            </div> */}

                            <div className="dashboard-container d-flex project_dashboard_sec build_box_dashboard_sec">
                                <div className="main-container">
                                    <div className="main-page-body-content">
                                        <div className="main-page-body-content-body">
                                            <div className="main-page-body-content-body-container">
                                                <div className="container-fluid">
                                                    <div className="sec-dashboard-header-title">
                                                        <div className="sec-header-new">
                                                            <button type="button" className="btn-header-transparent" >
                                                                <div className="border_box_view">
                                                                    <div className="border_box_view_inner">
                                                                        <div className="box_icon">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="64" viewBox="0 0 64 64" width="64"><g fill="#99ea24"><path d="m15 9c0-3.86599 3.134-7 7-7h15c3.866 0 7 3.13401 7 7 0 3.866-3.134 7-7 7h-15c-3.866 0-7-3.134-7-7z" /><path d="m13 9c0-.68739.0771-1.35678.223-2h-.223c-4.41828 0-8 3.5817-8 8v39c0 4.4183 3.58172 8 8 8h12v-21c0-4.9706 4.0294-9 9-9h20v-17c0-4.4183-3.5817-8-8-8h-.223c.1459.64322.223 1.31261.223 2 0 4.9706-4.0294 9-9 9h-15c-4.9706 0-9-4.0294-9-9z" /><path clip-rule="evenodd" d="m35.2143 34c-4.4699 0-8.2143 3.5162-8.2143 8v12c0 4.4838 3.7444 8 8.2143 8h15.5714c4.4699 0 8.2143-3.5162 8.2143-8v-12c0-4.4838-3.7444-8-8.2143-8zm2.7857 4h10v4c0 1.1046-.8954 2-2 2h-6c-1.1046 0-2-.8954-2-2z" fill-rule="evenodd" /></g></svg>
                                                                        </div>
                                                                        <div className="box_text_content">
                                                                            <div className="big_text">Sheet View</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </button>
                                                            <div className="header-left">
                                                                <div className="header-left-inner">
                                                                    <button type="button" className="btn-header-transparent close-icon" onClick={() => {
                                                                        closeButton(false);
                                                                    }}>
                                                                        <div className="border_box_view">
                                                                            <div className="border_box_view_inner">
                                                                                <div className="box_icon">
                                                                                    <IoCloseSharp />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-content customer-content">
                                <div className="container-fluid">
                                    <div className="table-container">
                                        <table className="table table-striped table-bordered">
                                            <thead >
                                                <tr>
                                                    <th>Club</th>
                                                    <th>Dexterity</th>
                                                    <th>Make</th>
                                                    <th>Model</th>
                                                    <th>Finish</th>
                                                    <th>Loft</th>
                                                    <th>Lie</th>
                                                    <th>Weight Ports</th>
                                                    <th>Shaft Make</th>
                                                    <th>Shaft Model</th>
                                                    <th>Shaft Wrap</th>
                                                    <th>Weight</th>
                                                    <th>Flex</th>
                                                    <th>Length</th>
                                                    <th>Tipping</th>
                                                    <th>Counter Balance</th>
                                                    <th>Grip Brand</th>
                                                    <th>Grip Model</th>
                                                    <th>Grip Size</th>
                                                    <th>Grip Label</th>
                                                    <th>Grip Wrap</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.title}</td>
                                                        <td>{item.Dexterity === "Lifty" ? "Lefty" : item.Dexterity}</td>
                                                        <td>{item.ClubHead.make}</td>
                                                        <td>{item.ClubHead.model}</td>
                                                        <td>{item.Finish}</td>
                                                        <td>{item.Loft + " Degree"}</td>
                                                        <td>{item.Lie + " Degree"}</td>
                                                        <td>
                                                            {(item.WeightPorts.color && item.WeightPorts.weight)
                                                                ? `${item.WeightPorts.color} / ${item.WeightPorts.weight} Gram`
                                                                : "None"}
                                                        </td>

                                                        <td>{item.Shaft.make}</td>
                                                        <td>{item.Shaft.model}</td>
                                                        <td>{item.ShaftWrap || "None"}</td>
                                                        <td>{item.Weight + " Gram"}</td>
                                                        <td>{item.Flex + " CPM"}</td>
                                                        <td>{item.Length + " Inch"}</td>
                                                        <td>{item.TippingStatus === false ? "None" : `${item.Tripping} Inch`}</td>
                                                        <td>{item.CounterBalance ? item.CounterBalance + " Gram" : "None"}</td>
                                                        <td>{item.Grip.brand}</td>
                                                        <td>{item.Grip.model}</td>
                                                        <td>{item.Grip.size}</td>
                                                        <td>{item.Grip.label}</td>
                                                        <td>{item.GripWrapStatus === false ? "None" : `${item.GripWrapValue}`}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        </>
    );
}



export default BuildsheetInsights;